class InstalatorRegistrationUsersController {
  static controller($scope, $state, InstalatorRegistrationService) {
    'ngInject';

    $scope.registerInstalator = function(instalatorRegistration) {
      if(instalatorRegistration.$valid) {
        var promise = InstalatorRegistrationService.register(instalatorRegistration)
        promise.then(function(){
          $state.go('public.users.instalator.instalator-registration-confirm');
        });
      }
    };
  };
}

export default InstalatorRegistrationUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/instalator/instalator-registration.users.controller.js